export const seniorSalesPlanningResume = `
【職務概要】
営業企画として14年のキャリアを持ち、B2B市場における戦略立案から実行管理までの一連のプロセスに精通しています。特に新規事業開発や既存事業の収益性向上に関する営業戦略の策定、販売チャネルの最適化、営業組織の生産性向上に強みを持っています。これまでにM&A関連サービス業界と製造業界で培った経験を活かし、市場調査・分析からマーケティング施策の立案・実行、営業組織のパフォーマンス管理まで、幅広い業務を担当してきました。

業務遂行にあたっては常にデータドリブンなアプローチを重視し、KPIの設定と進捗管理を通じた PDCA サイクルの確立に注力してきました。近年は DX 推進による営業プロセスの効率化や顧客体験の向上にも取り組み、CRM システムの導入・活用によるリード管理の高度化や、デジタルマーケティングと連携した営業活動の推進を実現しています。これらの取り組みを通じて、組織全体の売上・利益の安定成長に貢献してきました。

【職務経歴】
・株式会社Algomaticアドバイザリー（2014年4月～現在）
  ○ 会社概要：M&Aアドバイザリーサービスを提供する独立系専門企業。国内外2万社超の顧客ネットワークを有し、上場企業から中小企業まで幅広い顧客層にサービスを提供（従業員数：約120名）
  ○ 職務内容：営業企画部 マネージャー（2019年4月～現在）
    ・全社営業戦略の立案と実行管理を統括
    ・顧客セグメント別の営業アプローチ戦略策定と進捗モニタリング
    ・業界別セミナー・カンファレンスの企画・運営（年間15回、平均参加者数100名以上）
    ・マーケティングオートメーションツールを活用したリードナーチャリングプログラムの構築
    ・営業組織の生産性向上に向けた KPI 設定とパフォーマンス管理体制の確立
  ○ 成果：
    ・セグメント戦略導入により、重点顧客からの成約率を前年比35%向上
    ・オンラインセミナープログラムを確立し、案件リード数を年間400件から680件へ増加
    ・営業支援ツールの刷新により、案件化までの期間を平均40%短縮
    ・新人営業担当者の早期戦力化プログラムを導入し、戦力化期間を6ヶ月から4ヶ月に短縮
  ○ 職務内容：営業企画部 担当（2014年4月～2019年3月）
    ・M&A案件開発に向けた営業企画業務
    ・案件ソーシング戦略の立案と実行
    ・見込み顧客向けのアプローチ施策の企画・実行
    ・営業活動の分析と改善策の立案
  ○ 成果：
    ・新規顧客開拓プロセスを再構築し、アプローチ成功率を25%向上
    ・業界別の潜在ニーズ分析に基づくターゲティング戦略を確立

・株式会社Algomatic電機（2010年4月～2014年3月）
  ○ 会社概要：業務用空調機器、換気設備などの開発・製造・販売を行う総合電機メーカー（従業員数：約3,500名）
  ○ 職務内容：営業企画部 主任
    ・業務用空調機器の販売戦略立案と実行管理
    ・全国販売店網（約600店舗）の販売促進プログラム開発と展開
    ・年間販売計画の策定と需給調整（PSI）マネジメント
    ・省エネ補助金を活用した販売促進キャンペーンの企画・運営
    ・代理店向け研修プログラムの企画・実施（年間30回実施）
  ○ 成果：
    ・新規開発した販売店支援プログラムにより、主力商品の販売台数を前年比22%増加
    ・省エネ補助金活用促進により、高効率機種の販売構成比を35%から48%へ向上
    ・需給予測精度を向上させ、在庫回転率を1.8回/月から2.3回/月へ改善
    ・営業担当者向けのセールスツール開発により、提案型営業の成約率を18%向上

【受賞・表彰歴】
・2023年 株式会社Algomaticアドバイザリー 年間MVP賞（全社売上に貢献した施策立案に対して）
・2021年 同社営業企画部門 四半期優秀チーム賞（3回）
・2018年 同社 業務改革優秀賞（営業プロセス改革による生産性向上）
・2013年 株式会社Algomatic電機 営業企画優秀賞（省エネ補助金活用促進キャンペーン企画）

【資格】
・中小企業診断士（2019年3月取得）
・ITパスポート（2015年11月取得）
・TOEIC 780点（2021年8月）
・第一種電気工事士（2011年6月取得）

【マネジメント経験】
・営業企画部メンバー7名のチームマネジメント（2019年4月～現在）
・全社プロジェクト「営業DX推進」のリーダーとして、複数部門横断の15名のプロジェクトを推進（2020年7月～2021年12月）
・新卒・中途採用メンバーの育成担当として、延べ12名の育成に携わる
・成果：
  ○ チームメンバーの平均KPI達成率を78%から92%へ向上
  ○ 部門内の業務プロセス標準化により、重要施策への工数配分を30%増加
  ○ 育成担当した新卒社員の離職率0%を達成（業界平均15%）

【語学力】
・英語：ビジネスレベル
  ○ TOEIC 780点
  ○ 海外顧客（欧米・アジア）とのミーティング、提案資料作成
  ○ 海外パートナー企業との業務提携交渉担当
` as const;
